module.exports = __webpack_public_path__ + "assets/2af3ead6d229d4f5d10912e25bac1319.png";